module.exports = __webpack_public_path__ + "fonts/fa-thin-100.b85420a.ttf";